const _ = `         __
        // \\,_
          \\\` ,\\
     __,.-" =__)
   ."        )
,_/   ,    \\/\\ 
\\_| // /  /  /
   /  /    `;
export {
  _ as default
};
